module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter3"
    }
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "href": "#/003toc#ch3"
    }
  }, [_vm._v("Crocked Beef Stock")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Many students ask about the difference between stock and broth. The easiest way to differentiate between stock and broth is that stock is made from browning the elements before simmering them for a long period of time to reduce and concentrate the flavors. Broth is made by simmering the elements for a shorter period of time, without browning the ingredients before adding the liquid. The resulting broth is not as deeply colored or as full-flavored as stock. Beef stock in the slow cooker is a two-step process. First, the bones and vegetables are slathered with a paste, then browned in a hot oven. The contents of the roasting pan is then added to the slow cooker along with more vegetables, herbs, and liquid to simmer all day. Once strained, this deeply colored and flavorful beef stock can be used in any preparation, from reduction sauces to old-fashioned soups. Once again, the slow cooker saves you the hassle of watching and stirring. Just set it and forget it.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("¼ cup tomato paste")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 teaspoons sugar")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 teaspoons salt")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 teaspoon freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("4 cloves garlic, minced")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 teaspoons dried thyme")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 teaspoon dried sage")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("3 large sweet onions, coarsely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("4 large carrots, coarsely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1½ pounds beef stew meat, cut into 1-inch pieces")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 pounds meaty beef bones, sawed in a few pieces (your butcher can do this for you)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("4 cups water")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("preheat the oven to 425°F. Line a baking sheet with a silicone baking liner or aluminum foil.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("stir together the tomato paste, sugar, salt, pepper, garlic, thyme, and sage in a large mixing bowl. Put the vegetables, meat, and bones in the bowl and rub the paste over them until they are coated.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("spread the mixture out on the baking sheet and bake for 30 minutes, turning the pieces once during the cooking process. Transfer the mixture with any liquid to the insert of a 5- to 7-quart slow cooker. Add the water and stir to blend.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("cover and cook on high for 4 to 5 hours or on low for 8 to 10 hours. Remove the solids from the stock, then strain the stock through a fine-mesh sieve into a bowl. Allow the stock to cool, and skim off the fat from the surface.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("refrigerate the stock for 3 days or freeze for up to 8 weeks. The meat from the stock may be frozen separately and used in soups, stews, or chilies.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("makes about 6 cups")])]), _vm._v(" "), _c('p', {
    staticClass: "breakhere"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2aad7ce8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/009-chapter3.vue
// module id = 81
// module chunks = 0